import { Box, Text } from '@nimbus-ds/components';
import { CancelAndConfirmButtons } from 'commons/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import { ProductSearcherFooterProps } from '../../ProductSearcher';

interface ProductSearcherConfirmTransferCardProps {
  footerProps: ProductSearcherFooterProps<false>;
}

export function ProductSearcherConfirmTransferCard({
  footerProps,
}: Readonly<ProductSearcherConfirmTransferCardProps>) {
  const t = useTranslationOrders();

  const totalProductsSelected = new Set(
    footerProps.selectedProducts.map((p) => p.productId),
  ).size;
  const totalVariantsSelected = footerProps.selectedProducts.length;
  const totalUnitsSelected = footerProps.selectedProducts.reduce(
    (acc, curr) => acc + (curr.stock ?? 0),
    0,
  );

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      width="100%"
    >
      <Box display="flex" flexDirection="column" justifyContent="space-between">
        <Box display="flex" flexDirection="row" gap="1">
          <Text fontSize="caption">
            {t('productSearcher.searcherConfirm.selectedProductsCount', {
              count: totalProductsSelected,
            })}
          </Text>
          <Text> / </Text>
          <Text fontSize="caption">
            {t('productSearcher.searcherConfirm.selectedVariantsCount', {
              count: totalVariantsSelected,
            })}
          </Text>
        </Box>
        <Text fontWeight="bold">
          {t('productSearcher.searcherConfirm.selectedUnitsCount', {
            count: totalUnitsSelected,
          })}
        </Text>
      </Box>
      <Box display="flex" alignItems="center">
        <CancelAndConfirmButtons
          onCancel={footerProps.onClose}
          onConfirm={footerProps.onSubmit}
          confirmText={t('productSearcher.searcherConfirm.addConfirm')}
        />
      </Box>
    </Box>
  );
}
